// Static class to facilitate communication
// between the AuthContextProvider and apollo onError handler.

type AuthEventSubscriber = () => Promise<string | undefined>;

class AuthStatusNotifier {
    private authEventPromise: Promise<string | undefined> | undefined = undefined;
    private onAuthEvent: AuthEventSubscriber | undefined;

    subscribe(subscriber: AuthEventSubscriber) {
        this.onAuthEvent = subscriber;
    }

    unsubscribe() {
        this.onAuthEvent = undefined;
    }

    onEvent(): Promise<string | undefined> {
        // Ensure only 1 auth event is happening at the same time.
        if (this.authEventPromise) return this.authEventPromise;
        if (!this.onAuthEvent) return Promise.resolve(undefined);

        this.authEventPromise = this.onAuthEvent().finally(() => {
            this.authEventPromise = undefined;
        });
        return this.authEventPromise;
    }
}

export default new AuthStatusNotifier();
